const readJson = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) {
    const message = payload.message || `Request failed (${response.status})`;
    const detail = payload.detail ? ` ${payload.detail}` : '';
    const errorId = payload.errorId ? ` (Error ${payload.errorId})` : '';
    throw new Error(`${message}${detail}${errorId}`);
  }
  return payload;
};

export const loadSet = (setId) =>
  fetch(`/api/sets/load_set.php?setId=${encodeURIComponent(setId)}`, {
    credentials: 'same-origin',
  }).then(readJson);

export const saveSet = (setId, modules) =>
  fetch(`/api/sets/save_set.php?setId=${encodeURIComponent(setId)}`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ modules }),
  }).then(readJson);

export const uploadSetImage = async (setId, file, assetRole = 'module') => {
  const body = new FormData();
  body.append('setId', setId);
  body.append('imageFile', file);
  body.append('assetRole', assetRole);
  const response = await fetch('/api/sets/upload_image.php', {
    method: 'POST', credentials: 'same-origin', body,
  });
  const payload = await readJson(response);
  return payload.asset;
};

export const discardSetImage = (setId, assetId) =>
  fetch('/api/sets/discard_image.php', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ setId, assetId }),
  }).then(readJson);

export const listMySets = () =>
  fetch('/api/sets/list_sets.php', { credentials: 'same-origin' }).then(readJson);

export const createSet = (data) =>
  fetch('/api/sets/create_set.php', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data),
  }).then(readJson);

export const updateSet = (data) =>
  fetch('/api/sets/update_set.php', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data),
  }).then(readJson);

export const deleteSet = (setId) =>
  fetch('/api/sets/delete_set.php', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ setId }),
  }).then(readJson);

export const getSetPickerCards = (parameters = {}, signal) => {
  const query = new URLSearchParams();
  Object.entries(parameters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, String(value));
  });
  return fetch(`/api/sets/get-user-cards.php?${query}`, { credentials: 'same-origin', signal }).then(readJson);
};

export const getSetCardFolders = (signal) =>
  fetch('/api/sets/get-user-cards.php?view=folders', { credentials: 'same-origin', signal }).then(readJson);
